import type { Nullable } from "../../../../../typescript"
import type { TilePositionXY } from "../../../tile_position_xy/TilePositionXY.type"
import isActionTypeGamePlay from "../action/isActionTypeGamePlay"
import type { ActionLog } from "../ActionLog.type"
import type { ActionUnionFlat } from "../ActionUnionFlat.type"

// Function to find position from action
export default function findMostRecentActionLogPosition(
  actionLogs: ActionLog[],
  isPlayingGame: boolean,
): Nullable<TilePositionXY> {

    // Find the most recent action with position data
    if (actionLogs.length > 0) {
      // Search backwards through action logs to find the most recent action with position
      for (let i = actionLogs.length - 1; i >= 0; i--) {
        const actionLog = actionLogs[i]
        if (isPlayingGame && !isActionTypeGamePlay(actionLog)) {
          // once we've hit a non game play action, we can stop
          return null
        }

        let position: Nullable<TilePositionXY> = null

        const action = (actionLog.action as ActionUnionFlat)
        position = action.position
          || action.dest_position
          || action.attack_position
          || actionLog.unit1
          || actionLog.factory0
          || actionLog.target1
          || actionLog.merge1
          || actionLog.annexed1
          || actionLog.taxi1

        if (position) {
          return position
        }
      }
    }

  return null
}